define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    var templateUrl = require('../views/helix.template.html');
    angular.module(MODULE_NAME)
        .component('ilmnUiHelixLoadingAnimation', {
            templateUrl: templateUrl
        });
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-loading-animation/scripts/helix.component.js
// module id = 32
// module chunks = 0 2